(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5744"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5744"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cljH0", function(module, exports) {

$parcel$export(module.exports, "createSVGGrid", () => $8fc6b8bbd146cdca$export$d47c320381fa2abf);
function $8fc6b8bbd146cdca$export$d47c320381fa2abf(container, squaresPerRow, fill, onlyEmbed) {
    if (!container) {
        console.error("Container not found");
        return;
    }
    // Get the container's dimensions
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    const responsiveSquares = window.innerWidth <= 991 ? squaresPerRow / 2 : squaresPerRow;
    // Calculate the size of each square
    const squareSize = parseInt(containerWidth / responsiveSquares);
    // Calculate the number of squares per column
    const squaresPerColumn = Math.ceil(containerHeight / squareSize);
    // Create a unique ID for the mask
    const maskId = "mask-" + Math.random().toString(36).substr(2, 9);
    if (!onlyEmbed) {
        // Create SVG content
        let svgContent = `
                <svg viewBox="0 0 ${containerWidth} ${containerHeight}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;">
                    <defs>
                        <mask id="${maskId}">
                            ${Array.from({
            length: squaresPerColumn
        }).map((_, row)=>Array.from({
                length: responsiveSquares
            }).map((_, col)=>{
                const x = col * squareSize;
                const y = row * squareSize;
                return `<rect x="${x}" y="${y}" width="${squareSize + 1}" height="${squareSize + 1}" fill="${fill ? fill : "#000000"}"/>`;
            }).join("")).join("")}
                        </mask>
                    </defs>
                </svg>`;
        // Create wrapper for the SVG and mask
        const maskContainer = document.createElement("div");
        maskContainer.className = "mask-container";
        maskContainer.style.maskImage = `url(#${maskId})`;
        // Append SVG to maskContainer
        maskContainer.innerHTML = svgContent;
        container.parentNode.insertBefore(maskContainer, container);
        maskContainer.appendChild(container);
        return maskContainer.querySelector("svg");
    } else {
        // Create SVG content
        let svgContent = `
                <svg viewBox="0 0 ${containerWidth} ${containerHeight}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style="position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;">
                            ${Array.from({
            length: squaresPerColumn
        }).map((_, row)=>Array.from({
                length: squaresPerRow
            }).map((_, col)=>{
                const x = col * squareSize;
                const y = row * squareSize;
                return `<rect x="${x}" y="${y}" width="${squareSize + 1}" height="${squareSize + 1}" fill="${fill ? fill : "#000000"}"/>`;
            }).join("")).join("")}
                </svg>`;
        container.insertAdjacentHTML("beforeend", svgContent);
        return svgContent;
    }
}

});

parcelRegister("2rxJM", function(module, exports) {

$parcel$export(module.exports, "setLinesWrapper", () => $1c7845f0e1de0887$export$8f060496e19d4bbb);
function $1c7845f0e1de0887$export$8f060496e19d4bbb(lines, callback) {
    // Wrap each line in a .line-wrapper span
    lines.forEach((line)=>{
        const wrapper = document.createElement("span");
        wrapper.classList.add("line-wrapper");
        line.parentNode.insertBefore(wrapper, line);
        wrapper.appendChild(line);
    });
    if (typeof callback === "function") callback();
}

});

function $6efbc8d1b8f19358$export$ebbd8862ad385694() {
    if (!document.querySelector(".news-slider")) return;
    const sliders = document.querySelectorAll(".news-slider_wrapper");
    sliders.forEach((s)=>{
        const slider = new Swiper(s.querySelector(".news-slider"), {
            slidesPerView: "auto",
            navigation: {
                nextEl: s.querySelector(".slider-controls .button.next"),
                prevEl: s.querySelector(".slider-controls .button.prev")
            }
        });
        // gsap logic
        const slides = s.querySelectorAll(".services-card");
        gsap.set(slides, {
            y: "3rem",
            opacity: 0
        });
        gsap.timeline({
            scrollTrigger: {
                trigger: s,
                start: "25% bottom",
                onEnter: ()=>{
                    gsap.to(slides, {
                        y: "0rem",
                        opacity: 1,
                        stagger: 0.1,
                        duration: 0.5,
                        ease: "expo.out"
                    });
                }
            }
        });
        slides.forEach((slide)=>{
            const video = slide.querySelector("video");
            video.pause();
            video.currentTime = 0;
            // let previewTimeout = null;
            slide.addEventListener("mouseenter", ()=>{
                $6efbc8d1b8f19358$var$startPreview(video);
            // previewTimeout = setTimeout(() => stopPreview(video), 4000);
            });
            slide.addEventListener("mouseleave", ()=>{
                // clearTimeout(previewTimeout);
                // previewTimeout = null;
                $6efbc8d1b8f19358$var$stopPreview(video);
            });
        });
    });
}
function $6efbc8d1b8f19358$var$startPreview(video) {
    video.muted = true;
    video.currentTime = 1;
    video.play();
}
function $6efbc8d1b8f19358$var$stopPreview(video) {
    video.currentTime = 0;
    video.pause();
}



var $cljH0 = parcelRequire("cljH0");

var $2rxJM = parcelRequire("2rxJM");
function $30e0a3439939b4cd$export$67e00ddefb174c98() {
    const wrapper = document.querySelector(".section.list-scroll"), sections = wrapper.querySelectorAll(".section-list-scroll_inner"), spacers = wrapper.querySelectorAll(".section-anchor"), anchorLinks = wrapper.querySelectorAll(".section-nav-item"), numbers = wrapper.querySelector(".scroll-list-numbers-inner"), numbersLength = numbers ? numbers.querySelectorAll("div").length : null;
    if (!sections) return;
    let currentIndex = 0;
    function updateNumbers(i) {
        if (currentIndex !== i) {
            gsap.to(numbers, {
                yPercent: Number((100 / numbersLength).toFixed(2)) * -i,
                duration: 1,
                ease: "expo.out"
            });
            currentIndex = i;
        }
    }
    // console.log(anchorLinks);
    sections.forEach((section, i)=>{
        const id = section.dataset.section || null;
        const trigger = spacers[i];
        const title = section.querySelector(".section-scroll-title > *"), descriptionEl = section.querySelector(".section-scroll-description"), descriptionType = descriptionEl.classList.contains("is-masked") ? "html" : "text";
        let anchorLink;
        if (anchorLinks) anchorLink = id ? wrapper.querySelector(`.section-nav-item[data-target="${id}"]`) : anchorLinks[i];
        let titleMaskEl, description;
        if (title && descriptionType !== "html") titleMaskEl = (0, $cljH0.createSVGGrid)(title, 10);
        if (descriptionType === "html") description = (0, $cljH0.createSVGGrid)(descriptionEl.querySelector("div"), 10);
        else {
            descriptionInner = descriptionEl.querySelector("p");
            if (descriptionInner) {
                const descriptionEls = new SplitType(descriptionInner, {
                    types: "lines",
                    tagName: "span"
                });
                (0, $2rxJM.setLinesWrapper)(descriptionEls.lines, ()=>{
                    description = descriptionInner.querySelectorAll(".line");
                });
            }
        }
        $30e0a3439939b4cd$var$setListSectionScroll({
            trigger: trigger,
            isFirst: i === 0,
            isLast: i === sections.length - 1,
            titleMaskEl: titleMaskEl,
            description: {
                type: descriptionType,
                el: description
            },
            anchorLink: anchorLink,
            onComplete: ()=>{
                if (numbers) updateNumbers(i);
            }
        });
    });
}
function $30e0a3439939b4cd$var$setListSectionScroll(settings) {
    const { trigger: trigger, isFirst: isFirst, isLast: isLast, titleMaskEl: titleMaskEl, description: description, anchorLink: anchorLink, onComplete: onComplete } = settings;
    let squaresTitle, squaresDescription;
    if (titleMaskEl) squaresTitle = titleMaskEl.querySelectorAll("rect");
    if (description.type === "html") squaresDescription = description.el.querySelectorAll("rect");
    if (!isFirst) {
        if (titleMaskEl) gsap.set(squaresTitle, {
            opacity: 0
        });
        if (description.type === "html") gsap.set(squaresDescription, {
            opacity: 0
        });
        else gsap.set(description.el, {
            yPercent: 105
        });
    } else {
        if (titleMaskEl) gsap.set(squaresTitle, {
            opacity: 1
        });
        if (description.type === "html") gsap.set(squaresDescription, {
            opacity: 1
        });
        if (anchorLink) anchorLink.classList.add("active");
    }
    const tl = gsap.timeline({
        paused: true
    });
    if (!isFirst) {
        if (titleMaskEl) tl.to(squaresTitle, {
            opacity: 1,
            duration: 0.01,
            stagger: {
                from: "random",
                each: 0.01
            },
            ease: "power4.inOut"
        }, 0);
        if (description.type === "html") tl.to(squaresDescription, {
            opacity: 1,
            duration: 0.005,
            stagger: {
                from: "random",
                each: 0.005
            },
            ease: "power4.inOut"
        }, 0);
        if (description.type === "text" && description.el) tl.to(description.el, {
            yPercent: 0,
            stagger: 0.02,
            duration: 0.5,
            ease: "power4.inOut"
        }, // `-=${squaresVideoTiming}`
        0);
    }
    if (description.type === "html") {
        tl.addPause(0.5);
        tl.addLabel("out", 0.5);
    }
    if (titleMaskEl) tl.to(squaresTitle, {
        opacity: 0,
        duration: 0.01,
        stagger: {
            from: "random",
            each: 0.01
        },
        ease: "power4.inOut"
    }, 0.5);
    if (description.type === "html") tl.to(squaresDescription, {
        opacity: 0,
        duration: 0.005,
        stagger: {
            from: "random",
            each: 0.005
        },
        ease: "power4.inOut"
    }, 0.5);
    if (description.type === "text" && description.el) tl.to(description.el, {
        yPercent: -105,
        stagger: 0.02,
        duration: 0.5,
        ease: "power4.inOut"
    }, 0.5);
    if (description.type !== "html") {
        tl.addPause(0.5);
        tl.addLabel("out", 0.5);
    }
    gsap.timeline({
        scrollTrigger: {
            trigger: trigger,
            start: "top center",
            end: "bottom center",
            scrub: true,
            fastScrollEnd: 500,
            preventOverlaps: "scroll-list",
            pin: false,
            // markers: true,
            onEnter: ()=>{
                if (!isFirst) {
                    tl.play();
                    if (typeof onComplete === "function") onComplete();
                    if (anchorLink) anchorLink.classList.add("active");
                }
            },
            onEnterBack: ()=>{
                if (!isLast) {
                    tl.progress(1).reverse();
                    if (typeof onComplete === "function") onComplete();
                    if (anchorLink) anchorLink.classList.add("active");
                }
            },
            onLeave: ()=>{
                if (!isLast) {
                    tl.seek("out").play();
                    if (typeof onComplete === "function") onComplete();
                    if (anchorLink) anchorLink.classList.remove("active");
                }
            },
            onLeaveBack: ()=>{
                if (!isFirst) {
                    tl.seek("out").reverse();
                    if (typeof onComplete === "function") onComplete();
                    if (anchorLink) anchorLink.classList.remove("active");
                }
            }
        }
    });
}


document.fonts.ready.then(()=>{
    (0, $6efbc8d1b8f19358$export$ebbd8862ad385694)();
    (0, $30e0a3439939b4cd$export$67e00ddefb174c98)();
});

})();
//# sourceMappingURL=services.js.map
